import React from "react";

export default function Loader({ minHeight = 200 }) {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span> 
      </div>
    </div>
  );
}
